<template>
  <div class="wrapper">
    <!-- 1.顶部标题 -->
    <el-row>
      <h3 class="title">
        <div class="block">
          <span> <span style="cursor: pointer;" @click="cancel()">路由策略管理</span> > {{showTitle()}}</span>
        </div>
      </h3>
    </el-row>
    <el-scrollbar class="scrollbar-wrap">
    <!-- 2.步骤 -->
    <el-row>
      <el-col :span="16" :offset="4">
        <el-steps class="system-step" :active="acdStepIndex" finish-status="success" align-center>
          <el-step title="基本信息"></el-step>
          <el-step title="分配策略"></el-step>
          <el-step title="排队策略"></el-step>
        </el-steps>
      </el-col>
    </el-row>
    <stepOne
      v-if="acdStepIndex===1"
    />
    <stepTwo
      v-if="acdStepIndex===2"
    />
    <stepThree
      v-if="acdStepIndex===3"
    />
    </el-scrollbar>
  </div>
</template>

<script>
import stepOne from './stepOne'
import stepTwo from './stepTwo'
import stepThree from './stepThree'
export default {
  name: 'strategyStep',
  data() {
    return {
      // acdStepIndex: 1
    }
  },
  computed: {
    acdStepIndex() {
      return this.$store.state.user.acdStepIndex
    },
    curAcdId() { // 从策略列表跳转到详情时的缓存
      return this.$store.state.user.curAcdId
    }
  },
  props: [

  ],
  components: {
    stepOne,
    stepTwo,
    stepThree
  },
  // computed() {
  //
  //  },
  mounted() {

  },
  methods: {
    showTitle() {
      return this.curAcdId ? '编辑策略' : '新建策略'
    },
    cancel() {
      this.$store.commit('user/setAcdPageIndex', { acdPageIndex: 1 })
      this.$store.commit('user/setAcdStepIndex', { acdStepIndex: 1 })
    }
  }
}
</script>
<style lang="scss" scoped>
  .wrapper {
    height: 100%;
  }
  .scrollbar-wrap {
    height: calc(100% - 60px);
  }
</style>
